let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("bVOQk")).then(() => parcelRequire('9uj17'));